var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.155,
    height: 15.056,
    viewBox: "0 0 15.155 15.056",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6632",
    "data-name": "Group 6632",
    transform: "translate(6437.074 9386.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M0,0H15V15H0Z",
    transform: "translate(-6437 -9386)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(-6436.574 -9385.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit_Icon",
    "data-name": "Edit Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(4.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(6.762 1.006)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x2: 1.383,
    y2: 1.302,
    fill: "none",
    stroke: "#14a4c2",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M-329.062,175.868l2.8-1.362,7.038-7.067-1.517-1.472-7.021,7.051Z",
    transform: "translate(329.062 -166.409)",
    fill: "none",
    stroke: "#ffa539",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M-382.82,152.3h-7.662V165.38h13.318v-7.823",
    transform: "translate(390.481 -151.764)",
    fill: "none",
    stroke: "#14a4c2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.695ab68e4dca0e89801fcad55e6d2bd7.svg";
export { ForwardRef as ReactComponent };